import { defineMessages } from 'react-intl';

export const scope = 'app.components.account_settings.language_select';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'Language Settings',
  },
  change_language_placeholder: {
    id: `${scope}.change_language_placeholder`,
    defaultMessage: 'Change Language',
  },
  submit: {
    id: `${scope}.submit`,
    defaultMessage: 'Save Changes',
  },
  change_lang: {
    id: `${scope}.change_lang`,
    defaultMessage: 'Change Language*',
  },
  flag_alt: {
    id: `${scope}.flag_alt`,
    defaultMessage: 'flag',
  },
});
